module.exports = __webpack_public_path__ + "img/scene2-16.7d7181f2.jpg";